import Mapa from "layouts/mapa";
import SignIn from "layouts/authentication/sign-in/index";
import Icon from "@mui/material/Icon";
import TestView from "layouts/test";
import PerfilView from "layouts/perfil";
import HistoricoView from "layouts/historico";
import EntregadoresView from "layouts/entregadores";
import RelatoriosView from "layouts/relatorios";

const routes = [
  {
    type: "collapse",
    name: "Mapa de Pedidos",
    key: "mapa",
    icon: <Icon fontSize="small">maps</Icon>,
    route: "/mapa",
    component: <Mapa />,
  },
  {
    type: "route",
    name: "Login",
    key: "login",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/login",
    component: <SignIn />,
  },
  {
    type: "route",
    name: "test",
    key: "test",
    icon: <Icon fontSize="small">test</Icon>,
    route: "/test",
    component: <TestView />,
  },
  {
    type: "route",
    name: "perfil",
    key: "perfil",
    icon: <Icon fontSize="small">perfil</Icon>,
    route: "/perfil",
    component: <PerfilView />,
  },
  {
    type: "route",
    name: "historico",
    key: "historico",
    icon: <Icon fontSize="small">historico</Icon>,
    route: "/historico",
    component: <HistoricoView />,
  },
  {
    type: "route",
    name: "entregadores",
    key: "entregadores",
    icon: <Icon fontSize="small">entregadores</Icon>,
    route: "/entregadores",
    component: <EntregadoresView />,
  },
  {
    type: "route",
    name: "relatorios",
    key: "relatorios",
    icon: <Icon fontSize="small">assessment</Icon>,
    route: "/relatorios",
    component: <RelatoriosView />,
  },
];

export default routes;
